import CheckoutStep, { CheckoutStepModelProps } from '@/models/checkout/CheckoutStep';
import StoreLocation from '@/models/locations/StoreLocation';

// Step Data Props
export interface StepBuylistLocationDataProps {
	location: StoreLocation | null;
}

// JS Model Props
export interface StepBuylistLocationModelProps extends CheckoutStepModelProps {
	data: Partial<StepBuylistLocationDataProps>;
}

// API Response Props
// No API props; data stored locally only

// Constructor Props
export type StepBuylistLocationCtorProps = StepBuylistLocationModelProps;

export default class StepBuylistLocation extends CheckoutStep {

	location: StoreLocation | null;

	constructor(props: StepBuylistLocationCtorProps) {
		
		const mappedProps = StepBuylistLocation.mapStepDataToModel(props);

		super(props);

		this.location = mappedProps.location;
	}

	// Explicitly map API response to the internal model format
	private static mapStepDataToModel(props: StepBuylistLocationCtorProps): StepBuylistLocationDataProps {
				
		return {
			location: props.data?.location ?? null,
		};
	}
}